export default {
  setPopularSearches(state, value) {
    state.popularSearches = value
  }
}
